import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextareaComponent } from './textarea.component';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [TextareaComponent],
    imports: [
        CommonModule,
        MatInputModule,
        ReactiveFormsModule,
    ],
    exports: [
        TextareaComponent,
    ],
})
export class TextareaModule { }
